<mat-card class="mat-elevation-z8 container-card">
    <app-search-bar [filterFields]="['name']" [filterMap]="{ name: ['name'] }" [filterLabels]="{ name: ['Nome'] }" (filtersChanged)="onFilterChanged($event)">
    </app-search-bar>

    <app-shared-table [dataSource]="dataSourceClient" [displayedColumns]="['name', 'description', 'actions']" [columnLabels]="{ name: 'Nome Client', description: 'Descrizione' }" [enableRowClick]="true" [length]="totalItems" [pageSize]="pageSize" [pageIndex]="pageIndex"
        (pageChanged)="onPageChanged($event)" (sortChanged)="onSortChanged($event)" (openModal)="openDialog($event)" (rowClick)="goToDetail($event)" [isLoading]="isLoading" [hasError]="hasError">
    </app-shared-table>

    <app-loading [showLoading]="isLoadingFullScreen"></app-loading>
</mat-card>